/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
import React from 'react';

import { FLink } from '@components';
import { useSelector } from 'react-redux';
import { mdiCardAccountDetailsOutline } from '@mdi/js';
import Icons from '../../Icon';
import { MEUS_DADOS } from '../../../utils/paths';
import { multipleFormatString } from '../../../utils/formatString';

export const DadosPessoaisCard = () => {
  const dados = useSelector((state) => state.user.dadosPessoais);

  const celular =
    dados.celular || dados.endereco?.celular || dados.telefone || '';
  const telefone = dados.telefone || dados.endereco?.telefone || '';
  const email = dados.email || dados.endereco?.email || '';
  const cidade = dados.cidade || dados.endereco?.cidade || '';
  const bairro = dados.bairro || dados.endereco?.bairro || '';
  const complemento = dados.complemento || dados.endereco?.complemento || '';
  const numero = dados.numero || dados.endereco?.numero || '';
  const logradouro = dados.logradouro || dados.endereco?.logradouro || '';
  const custom = useSelector((state) => state.configs.tema);

  const CELULAR_TELEFONE =
    celular + (celular && telefone && ` | `) + telefone || 'Não informado';

  const EMAIL = (email || '').toLowerCase() || 'Não informado';

  const ENDERECO_COMPLETO = `
    ${logradouro ? multipleFormatString(`${logradouro} ${numero}`) : 'Não informado'}
    ${complemento ? multipleFormatString(` - ${complemento}`) : ''}
    ${bairro ? multipleFormatString(`, ${bairro} - ${cidade}`) : ''}
  `;

  return (
    <div className="card">
      <div className="card-body">
        <Icons
          path={mdiCardAccountDetailsOutline}
          color={custom.codCorLaranja}
          size={2}
          style={{ marginBottom: 10 }}
        />

        <h1 className="ts-20 fw-bold mb-2">Seus dados estão corretos?</h1>
        <p className="ts-14 text-muted mb-md-4">
          Verifique se seus dados de contato e endereço estão atualizados.
        </p>

        <p className="fw-bold text-orange ts-16">Email</p>
        <p className="fw-bold text-muted ts-16">{EMAIL}</p>

        <p className="fw-bold text-orange ts-16 mt-3">Celular</p>
        <p className="fw-bold text-muted ts-16">{CELULAR_TELEFONE}</p>

        <p className="fw-bold text-orange ts-16 mt-3">Endereço</p>
        <p className="fw-bold text-muted ts-16">{ENDERECO_COMPLETO}</p>
      </div>
      <div className="card-footer">
        <hr />
        <FLink className="mt-4" to={MEUS_DADOS} icon>
          Acessar meus dados
        </FLink>
      </div>
    </div>
  );
};
